import { render, staticRenderFns } from "./CasesPage.vue?vue&type=template&id=0987e62b&"
import script from "./CasesPage.vue?vue&type=script&lang=js&"
export * from "./CasesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0987e62b')) {
      api.createRecord('0987e62b', component.options)
    } else {
      api.reload('0987e62b', component.options)
    }
    module.hot.accept("./CasesPage.vue?vue&type=template&id=0987e62b&", function () {
      api.rerender('0987e62b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CasesPage/CasesPage.vue"
export default component.exports